import React from "react";
import Slider from "react-slick";
import useClientReady from "./useClientReady";

// react-slick is not hydration-safe: after mounting it measures the viewport, applies
// responsive breakpoints, clones slides and adds arrows/dots, so its DOM never equals what
// it rendered on the very first pass. Because the prerender script snapshots the page
// after mount, hydrating that snapshot always failed inside every carousel (React #418/#425).
//
// Fix: the carousel only mounts after hydration. Until then (and in the prerender
// snapshot, where scripts/prerender.js sets window.__PRERENDER__ so it never mounts) the
// slides are rendered as a plain static row. Both sides therefore render identical
// markup on the first pass, crawlers still get every slide's text, and visitors get the
// full carousel as soon as the page hydrates.
export default function HydrationSafeSlider({ settings, children }) {
  const ready = useClientReady();

  if (ready) return <Slider {...settings}>{children}</Slider>;

  const perRow = Math.max(1, Math.min(settings.slidesToShow || 1, React.Children.count(children) || 1));
  return (
    <div style={{ display: "flex", overflow: "hidden" }}>
      {React.Children.map(children, (child, i) => (
        <div key={i} style={{ flex: `0 0 ${100 / perRow}%`, minWidth: 0 }}>
          {child}
        </div>
      ))}
    </div>
  );
}
